import type { Security } from '@talos/kyoko';

type ProductTemplateBlotterRow = {
  TemplateSymbol?: string;
};

type ProductTemplateBlotterTooltipParams = {
  data?: ProductTemplateBlotterRow;
  context?: {
    current?: {
      securitiesBySymbol?: Map<string, Security>;
    };
  };
};

export function getProductTemplateBlotterTooltipValue(params: ProductTemplateBlotterTooltipParams): Security | null {
  const symbol = params.data?.TemplateSymbol;
  if (symbol == null || symbol === '') {
    return null;
  }

  return params.context?.current?.securitiesBySymbol?.get(symbol) ?? null;
}

export function getProductTemplateBlotterDisplayValue(params: ProductTemplateBlotterTooltipParams): string {
  return getProductTemplateBlotterTooltipValue(params)?.DisplaySymbol ?? '';
}
